import type { TFunction } from 'i18next';

/**
 * Maps backend failure codes (from either SimulationDocumentResponse.failureReason
 * on terminal-failed docs or synchronous upload rejections) to user-facing
 * localized messages. The backend never returns localized strings; it returns
 * stable codes. Keep this switch as the single mapping point so new codes
 * only need one i18n key and one case.
 */
export function translateDocumentFailure(t: TFunction, code: string | null | undefined): string {
  if (!code) return t('documents.failure.unknown');
  switch (code) {
    case 'EMPTY_OR_SCANNED_DOCUMENT':
      return t('documents.failure.emptyOrScanned');
    case 'CORRUPT_FILE':
      return t('documents.failure.corrupt');
    case 'PASSWORD_PROTECTED':
      return t('documents.failure.passwordProtected');
    case 'UNSUPPORTED_FORMAT':
      return t('documents.failure.unsupportedFormat');
    case 'LEGACY_PPT_NOT_SUPPORTED':
      return t('documents.failure.legacyPpt');
    case 'LEGACY_DOC_NOT_SUPPORTED':
      return t('documents.failure.legacyDoc');
    case 'LEGACY_XLS_NOT_SUPPORTED':
      return t('documents.failure.legacyXls');
    case 'EXCEL_NOT_SUPPORTED':
      return t('documents.failure.excelNotSupported');
    case 'INVALID_FILE_TYPE':
      return t('documents.failure.invalidFileType');
    case 'FILE_TOO_LARGE':
      return t('documents.failure.fileTooLarge');
    default:
      return t('documents.failure.unknown');
  }
}
